// Business Initiative portal design system
// Shared colors, typography, and basic component styles

export const colors = {
  // Primary
  background: '#F7F7F7',
  blue: '#0063A0',
  green: '#629E2D',
  // Secondary
  darkBlue: '#081545',
  lightBlue: '#0085FF',
  red: '#DD5349',
  // Semantic
  success: '#629E2D',
  error: '#DD5349',
  warning: '#EFCC00',
  info: '#0063A0',
  // Neutrals
  white: '#FFFFFF',
  gray50: '#FAFAFA',
  gray100: '#F5F5F5',
  gray200: '#EEEEEE',
  gray300: '#CCCCCC',
  gray400: '#999999',
  gray500: '#777777',
  gray600: '#555555',
  gray700: '#333333',
  darkGray: '#333333',
  midGray: '#777777',
  lightGray: '#CCCCCC',
  lighterGray: '#EEEEEE',
  borderColor: '#CCCCCC',
};

export const gradients = {
  blueToGreen: 'linear-gradient(180deg, #0063A0 0%, #629E2D 100%)',
  blueToGreenSubtle: 'linear-gradient(180deg, rgba(0, 99, 160, 0.1) 0%, rgba(98, 158, 45, 0.1) 100%)',
  blueToGreenHorizontal: 'linear-gradient(90deg, #0063A0 0%, #629E2D 100%)',
  blueToGreenHorizontalSubtle: 'linear-gradient(90deg, rgba(0, 99, 160, 0.1) 0%, rgba(98, 158, 45, 0.1) 100%)',
};

export const fonts = {
  heading: "'Avenir Next', 'Helvetica Neue', Helvetica, sans-serif",
  body: "'Avenir Next', 'PT Serif', Georgia, 'Times New Roman', serif",
};

export const typography = {
  h1: { fontSize: '2.5rem', fontWeight: 600, lineHeight: 1.2 },
  h2: { fontSize: '1.875rem', fontWeight: 600, lineHeight: 1.3 },
  h3: { fontSize: '1.5rem', fontWeight: 600, lineHeight: 1.4 },
  h4: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.4 },
  h5: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.4 },
  h6: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
  body: { fontSize: '1rem', lineHeight: 1.6 },
  small: { fontSize: '0.875rem', lineHeight: 1.5 },
  caption: { fontSize: '0.75rem', lineHeight: 1.4 },
};

export const spacing = {
  xs: '0.25rem',   // 4px
  sm: '0.5rem',   // 8px
  md: '1rem',     // 16px
  lg: '1.5rem',   // 24px
  xl: '2rem',     // 32px
  '2xl': '3rem',  // 48px
  '3xl': '4rem',  // 64px
};

export const layout = {
  containerMaxWidth: '1200px',
  pagePadding: '2rem 1rem',
  cardPadding: '2rem',
  borderRadius: '19px',
  boxShadow: '0px 4px 14px 0px rgba(0, 99, 160, 0.10)',
};

export const components = {
  primaryButton: {
    fontFamily: fonts.heading,
    fontSize: '1rem',
    fontWeight: 500,
    padding: '0.5rem 1rem',
    borderRadius: layout.borderRadius,
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: colors.blue,
    color: colors.white,
  },
  tableHeaderCell: {
    backgroundColor: colors.background,
    fontFamily: fonts.heading,
    fontWeight: 600,
    padding: '0.75rem',
    textAlign: 'left',
    borderBottom: `2px solid ${colors.lightGray}`,
    color: colors.darkGray,
  },
  tableCell: {
    padding: '0.75rem',
    borderBottom: `1px solid ${colors.lighterGray}`,
    color: colors.darkGray,
  },
};
